import React from 'react';
import {useSnackbar} from 'notistack';
import Icon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  icon: {
    fontSize: 20,
  },
}));

interface Props {
  key: number;
}

const CloseIcon: React.FC<Props> = ({key}) => {
  const {closeSnackbar} = useSnackbar();
  const classes = useStyles();
  return (
    <IconButton
      key='close'
      aria-label='close'
      color='inherit'
      onClick={() => {
        closeSnackbar(key);
      }}>
      <Icon className={classes.icon} />
    </IconButton>
  );
};

export default CloseIcon;
